

const initialState = {
  currentLanguage: 'cn',
  token: '',
  role: '',
  username: '',
  CompanyData: '',
}
  
function reducer(state = initialState, action) {
  switch (action.type) {
  case 'SET_LANGUAGE':
    localStorage.setItem("currentLanguage", action.payload);
    return {
      ...state,
      currentLanguage: action.payload,
    };
  case 'LOGIN_STATUS':
    return {
      ...state,
      username: action.payload.username,
      role: action.payload.role,
      token: action.payload.token,
    };
  case 'COMPANY_STATUS':
    return {
      ...state,
      CompanyData: action.payload.CompanyData,
    };
  default:
    return state;
  }
}
  
export default reducer
  